import { render, staticRenderFns } from "./exitPrompt.vue?vue&type=template&id=70932861&scoped=true&"
import script from "./exitPrompt.vue?vue&type=script&lang=js&"
export * from "./exitPrompt.vue?vue&type=script&lang=js&"
import style0 from "./exitPrompt.vue?vue&type=style&index=0&id=70932861&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70932861",
  null
  
)

export default component.exports